<template>
  <component
    :is="routerLink ? 'Link' : 'div'"
    defaultElement="div"
    :routerLink="routerLink"
    :class="[
      $style.base,
      $style[size],
      $style[color],
      {
        [$style.clickable]: clickable,
        [$style.disabled]: disabled
      }
    ]"
    @click="$emit('click', $event)"
  >
    <div :class="$style.wrap">
      <div :class="$style.inner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          :viewBox="viewBox"
          :class="[
            $style.svg,
            {
              [$style.customIcon]:
                name === 'calendar-day' ||
                name === 'calendar-week' ||
                name === 'calendar-month' ||
                name === 'email-open'
            }
          ]"
        >
          <g v-if="name === 'layers'">
            <path
              d="M21 11.35a1 1 0 0 0-.61-.86l-2.15-.92 2.26-1.3a1 1 0 0 0 .5-.92 1 1 0 0 0-.61-.86l-8-3.41a1 1 0 0 0-.78 0l-8 3.41a1 1 0 0 0-.61.86 1 1 0 0 0 .5.92l2.26 1.3-2.15.92a1 1 0 0 0-.61.86 1 1 0 0 0 .5.92l2.26 1.3-2.15.92a1 1 0 0 0-.61.86 1 1 0 0 0 .5.92l8 4.6a1 1 0 0 0 1 0l8-4.6a1 1 0 0 0 .5-.92 1 1 0 0 0-.61-.86l-2.15-.92 2.26-1.3a1 1 0 0 0 .5-.92zm-9-6.26 5.76 2.45L12 10.85 6.24 7.54zm-.5 7.78a1 1 0 0 0 1 0l3.57-2 1.69.72L12 14.85l-5.76-3.31 1.69-.72zm6.26 2.67L12 18.85l-5.76-3.31 1.69-.72 3.57 2.05a1 1 0 0 0 1 0l3.57-2.05z"
              data-name="layers"
            />
          </g>
          <g v-if="name === 'flag'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18 14.586c-.396.177-1.175.414-2.5.414-1.124 0-2.101-.383-3.135-.788-1.162-.455-2.364-.926-3.865-.926-1.057 0-1.876.127-2.5.298V5.416C6.396 5.239 7.177 5 8.5 5c1.124 0 2.101.383 3.135.788 1.162.455 2.364.926 3.865.926.938 0 1.776-.101 2.5-.3v8.172Zm1.268-9.906a1.79 1.79 0 0 0-1.599-.253c-.576.187-1.326.287-2.169.287-1.124 0-2.101-.383-3.135-.788C11.203 3.47 10.001 3 8.5 3c-2.887 0-4.005.952-4.2 1.144a.996.996 0 0 0-.3.713V20a1 1 0 1 0 2 0v-4.298c.395-.176 1.173-.416 2.5-.416 1.124 0 2.101.383 3.135.788 1.162.455 2.364.926 3.865.926 1.809 0 2.923-.378 3.541-.695.592-.307.959-.903.959-1.556V6.106c0-.56-.273-1.093-.732-1.426Z"
            />
          </g>
          <g v-if="name === 'clock'">
            <path
              d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"
            />
            <path
              class="cls-2"
              d="M16 11h-3V8a1 1 0 00-2 0v4a1 1 0 001 1h4a1 1 0 000-2z"
            />
          </g>
          <g v-if="name === 'copy'">
            <path
              d="M18 21h-6a3 3 0 01-3-3v-6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3zm-6-10a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1z"
            />
            <path
              d="M9.73 15H5.67A2.68 2.68 0 013 12.33V5.67A2.68 2.68 0 015.67 3h6.66A2.68 2.68 0 0115 5.67V9.4h-2V5.67a.67.67 0 00-.67-.67H5.67a.67.67 0 00-.67.67v6.66a.67.67 0 00.67.67h4.06z"
            />
          </g>
          <g v-if="name === 'edit'">
            <path
              d="M19.4 7.34L16.66 4.6A2 2 0 0014 4.53l-9 9a2 2 0 00-.57 1.21L4 18.91a1 1 0 00.29.8A1 1 0 005 20h.09l4.17-.38a2 2 0 001.21-.57l9-9a1.92 1.92 0 00-.07-2.71zM9.08 17.62l-3 .28.27-3L12 9.32l2.7 2.7zM16 10.68L13.32 8l1.95-2L18 8.73z"
            />
          </g>
          <g v-if="name === 'delete'">
            <path
              d="M21 6h-5V4.33A2.42 2.42 0 0013.5 2h-3A2.42 2.42 0 008 4.33V6H3a1 1 0 000 2h1v11a3 3 0 003 3h10a3 3 0 003-3V8h1a1 1 0 000-2zM10 4.33c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33V6h-4zM18 19a1 1 0 01-1 1H7a1 1 0 01-1-1V8h12z"
            />
            <path
              d="M9 17a1 1 0 001-1v-4a1 1 0 00-2 0v4a1 1 0 001 1zM15 17a1 1 0 001-1v-4a1 1 0 00-2 0v4a1 1 0 001 1z"
            />
          </g>
          <g v-if="name === 'check' || name === 'checkmark'">
            <path
              d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1 1 0 111.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33z"
            />
          </g>
          <g v-if="name === 'alert' || name === 'alert-triangle'">
            <path
              d="M22.56 16.3L14.89 3.58a3.43 3.43 0 00-5.78 0L1.44 16.3a3 3 0 00-.05 3A3.37 3.37 0 004.33 21h15.34a3.37 3.37 0 002.94-1.66 3 3 0 00-.05-3.04zm-1.7 2.05a1.31 1.31 0 01-1.19.65H4.33a1.31 1.31 0 01-1.19-.65 1 1 0 010-1l7.68-12.73a1.48 1.48 0 012.36 0l7.67 12.72a1 1 0 01.01 1.01z"
            />
            <circle cx="12" cy="16" r="1" />
            <path d="M12 8a1 1 0 00-1 1v4a1 1 0 002 0V9a1 1 0 00-1-1z" />
          </g>
          <g v-if="name === 'arrow-back'">
            <path
              d="M19 11H7.14l3.63-4.36a1 1 0 10-1.54-1.28l-5 6a1.19 1.19 0 00-.09.15c0 .05 0 .08-.07.13A1 1 0 004 12a1 1 0 00.07.36c0 .05 0 .08.07.13a1.19 1.19 0 00.09.15l5 6A1 1 0 0010 19a1 1 0 00.64-.23 1 1 0 00.13-1.41L7.14 13H19a1 1 0 000-2z"
            />
          </g>
          <g v-if="name === 'arrow-forward'">
            <path
              d="M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z"
            />
          </g>
          <g v-if="name === 'arrow-corner-up-right'">
            <path
              d="M19.78 10.38l-4-5a1 1 0 00-1.56 1.24l2.7 3.38H8a3 3 0 00-3 3v5a1 1 0 002 0v-5a1 1 0 011-1h8.92l-2.7 3.38a1 1 0 00.16 1.4A1 1 0 0015 17a1 1 0 00.78-.38l4-5a1 1 0 000-1.24z"
            />
          </g>
          <g v-if="name === 'arrow-corner-up-left'">
            <path
              d="M16 10H7.08l2.7-3.38a1 1 0 1 0-1.56-1.24l-4 5a1 1 0 0 0 0 1.24l4 5A1 1 0 0 0 9 17a1 1 0 0 0 .62-.22 1 1 0 0 0 .16-1.4L7.08 12H16a1 1 0 0 1 1 1v5a1 1 0 0 0 2 0v-5a3 3 0 0 0-3-3z"
            />
          </g>
          <g v-if="name === 'arrow-corner-down-left'">
            <path
              d="M20 6a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 1-.29.71A1 1 0 0 1 17 12H8.08l2.69-3.39a1 1 0 0 0-1.52-1.17l-4 5a1 1 0 0 0 0 1.25l4 5a1 1 0 0 0 .78.37 1 1 0 0 0 .62-.22 1 1 0 0 0 .15-1.41l-2.66-3.36h8.92a3 3 0 0 0 3-3z"
              data-name="corner-down-left"
            />
          </g>
          <g v-if="name === 'attach'">
            <path
              d="M9.29 21a6.23 6.23 0 01-4.43-1.88 6 6 0 01-.22-8.49L12 3.2A4.11 4.11 0 0115 2a4.48 4.48 0 013.19 1.35 4.36 4.36 0 01.15 6.13l-7.4 7.43a2.54 2.54 0 01-1.81.75 2.72 2.72 0 01-1.95-.82 2.68 2.68 0 01-.08-3.77l6.83-6.86a1 1 0 011.37 1.41l-6.83 6.86a.68.68 0 00.08.95.78.78 0 00.53.23.56.56 0 00.4-.16l7.39-7.43a2.36 2.36 0 00-.15-3.31 2.38 2.38 0 00-3.27-.15L6.06 12a4 4 0 00.22 5.67 4.22 4.22 0 003 1.29 3.67 3.67 0 002.61-1.06l7.39-7.43a1 1 0 111.42 1.41l-7.39 7.43A5.65 5.65 0 019.29 21z"
            />
          </g>
          <g v-if="name === 'heart'">
            <path
              d="M12 21a1 1 0 01-.71-.29l-7.77-7.78a5.26 5.26 0 010-7.4 5.24 5.24 0 017.4 0L12 6.61l1.08-1.08a5.24 5.24 0 017.4 0 5.26 5.26 0 010 7.4l-7.77 7.78A1 1 0 0112 21zM7.22 6a3.2 3.2 0 00-2.28.94 3.24 3.24 0 000 4.57L12 18.58l7.06-7.07a3.24 3.24 0 000-4.57 3.32 3.32 0 00-4.56 0l-1.79 1.8a1 1 0 01-1.42 0L9.5 6.94A3.2 3.2 0 007.22 6z"
            />
          </g>
          <g v-if="name === 'file'">
            <path
              d="M15 16H9a1 1 0 000 2h6a1 1 0 000-2zM9 14h3a1 1 0 000-2H9a1 1 0 000 2z"
            />
            <path
              d="M19.74 8.33l-5.44-6a1 1 0 00-.74-.33h-7A2.53 2.53 0 004 4.5v15A2.53 2.53 0 006.56 22h10.88A2.53 2.53 0 0020 19.5V9a1 1 0 00-.26-.67zM14 5l2.74 3h-2a.79.79 0 01-.74-.85zm3.44 15H6.56a.53.53 0 01-.56-.5v-15a.53.53 0 01.56-.5H12v3.15A2.79 2.79 0 0014.71 10H18v9.5a.53.53 0 01-.56.5z"
            />
          </g>
          <g v-if="name === 'file-empty'">
            <path
              d="M19.74 8.33l-5.44-6a1 1 0 00-.74-.33h-7A2.53 2.53 0 004 4.5v15A2.53 2.53 0 006.56 22h10.88A2.53 2.53 0 0020 19.5V9a1 1 0 00-.26-.67zM17.65 9h-3.94a.79.79 0 01-.71-.85V4h.11zm-.21 11H6.56a.53.53 0 01-.56-.5v-15a.53.53 0 01.56-.5H11v4.15A2.79 2.79 0 0013.71 11H18v8.5a.53.53 0 01-.56.5z"
            />
          </g>
          <g v-if="name === 'pdf'">
            <path
              d="M19.74 8.33l-5.44-6a1 1 0 00-.74-.33h-7A2.53 2.53 0 004 4.5v15A2.53 2.53 0 006.56 22h10.88A2.53 2.53 0 0020 19.5V9a1 1 0 00-.26-.67zM17.65 9h-3.94a.79.79 0 01-.71-.85V4h.11l4.54 5zm-.21 11H6.56a.532.532 0 01-.56-.5v-15a.53.53 0 01.56-.5H11v4.15A2.79 2.79 0 0013.71 11H18v8.5a.53.53 0 01-.56.5z"
            />
            <path
              d="M7.888 13.794H8.4a.6.6 0 00.408-.135.478.478 0 00.156-.373.467.467 0 00-.156-.372.572.572 0 00-.408-.141h-.513v1.021zm.603.767h-.609V16H7v-4h1.49c.403 0 .729.12.978.361.253.24.38.547.38.92 0 .38-.127.688-.38.925-.25.237-.575.355-.977.355zM11.28 15.16h.513c.324 0 .588-.098.793-.294.208-.196.312-.483.312-.863 0-.384-.104-.673-.312-.869-.205-.196-.47-.293-.793-.293h-.514v2.318zm.546.84h-1.429v-4h1.435c.6 0 1.08.18 1.44.542.365.36.548.848.548 1.46 0 .614-.183 1.101-.547 1.462-.361.357-.844.536-1.447.536zM15.336 16h-.888v-4H17v.846h-1.67v.847H16.8v.812h-1.463V16z"
            />
          </g>
          <g v-if="name === 'barcode'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4 3c.552 0 1 .403 1 .9v16.2c0 .497-.448.9-1 .9s-1-.403-1-.9V3.9c0-.497.448-.9 1-.9zM9 18a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM9 3c.552 0 1 .388 1 .867v11.266c0 .479-.448.867-1 .867s-1-.388-1-.867V3.867C8 3.388 8.448 3 9 3zM15 3c.552 0 1 .403 1 .9v16.2c0 .497-.448.9-1 .9s-1-.403-1-.9V3.9c0-.497.448-.9 1-.9zM20 3c.552 0 1 .403 1 .9v16.2c0 .497-.448.9-1 .9s-1-.403-1-.9V3.9c0-.497.448-.9 1-.9z"
            />
          </g>
          <g v-if="name === 'briefcase'">
            <path
              d="M19 7h-3V5.5A2.5 2.5 0 0013.5 3h-3A2.5 2.5 0 008 5.5V7H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3zm-4 2v10H9V9zm-5-3.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h-4zM4 18v-8a1 1 0 011-1h2v10H5a1 1 0 01-1-1zm16 0a1 1 0 01-1 1h-2V9h2a1 1 0 011 1z"
            />
          </g>
          <g v-if="name === 'pricetag' || name === 'pricetags'">
            <path
              d="M12.87 22a1.84 1.84 0 01-1.29-.53l-6.41-6.42a1 1 0 01-.29-.61L4 5.09a1 1 0 01.29-.8 1 1 0 01.8-.29l9.35.88a1 1 0 01.61.29l6.42 6.41a1.82 1.82 0 010 2.57l-7.32 7.32a1.82 1.82 0 01-1.28.53zm-6-8.11l6 6 7.05-7.05-6-6-7.81-.73z"
            />
            <circle cx="10.5" cy="10.5" r="1.5" />
          </g>
          <g v-if="name === 'gift'">
            <path
              d="M19.2 7h-.39A3 3 0 0019 6a3.08 3.08 0 00-3.14-3A4.46 4.46 0 0012 5.4 4.46 4.46 0 008.14 3 3.08 3.08 0 005 6a3 3 0 00.19 1H4.8A2 2 0 003 9.2v3.6A2.08 2.08 0 004.5 15v4.37A1.75 1.75 0 006.31 21h11.38a1.75 1.75 0 001.81-1.67V15a2.08 2.08 0 001.5-2.2V9.2A2 2 0 0019.2 7zM19 9.2v3.6a.56.56 0 010 .2h-6V9h6a.56.56 0 010 .2zM15.86 5A1.08 1.08 0 0117 6a1.08 1.08 0 01-1.14 1H13.4a2.93 2.93 0 012.46-2zM7 6a1.08 1.08 0 011.14-1 2.93 2.93 0 012.45 2H8.14A1.08 1.08 0 017 6zM5 9.2A.56.56 0 015 9h6v4H5a.56.56 0 010-.2zM6.5 15H11v4H6.5zm6.5 4v-4h4.5v4z"
            />
          </g>
          <g v-if="name === 'credit-card'">
            <path
              d="M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM4 8a1 1 0 011-1h14a1 1 0 011 1v1H4zm16 8a1 1 0 01-1 1H5a1 1 0 01-1-1v-5h16z"
            />
            <path
              d="M7 15h4a1 1 0 000-2H7a1 1 0 000 2zM15 15h2a1 1 0 000-2h-2a1 1 0 000 2z"
            />
          </g>
          <g v-if="name === 'calendar'">
            <path
              d="M18 4h-1V3a1 1 0 00-2 0v1H9V3a1 1 0 00-2 0v1H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V7a3 3 0 00-3-3zM6 6h1v1a1 1 0 002 0V6h6v1a1 1 0 002 0V6h1a1 1 0 011 1v4H5V7a1 1 0 011-1zm12 14H6a1 1 0 01-1-1v-6h14v6a1 1 0 01-1 1z"
            />
            <circle cx="8" cy="16" r="1" />
            <path d="M16 15h-4a1 1 0 000 2h4a1 1 0 000-2z" />
          </g>
          <g v-if="name === 'star'">
            <path
              d="M17.56 21a1 1 0 01-.46-.11L12 18.22l-5.1 2.67a1 1 0 01-1.45-1.06l1-5.63-4.12-4a1 1 0 01-.25-1 1 1 0 01.81-.68l5.7-.83 2.51-5.13a1 1 0 011.8 0l2.54 5.12 5.7.83a1 1 0 01.81.68 1 1 0 01-.25 1l-4.12 4 1 5.63a1 1 0 01-.4 1 1 1 0 01-.62.18zM12 16.1a.92.92 0 01.46.11l3.77 2-.72-4.21a1 1 0 01.29-.89l3-2.93-4.2-.62a1 1 0 01-.71-.56L12 5.25 10.11 9a1 1 0 01-.75.54l-4.2.62 3 2.93a1 1 0 01.29.89l-.72 4.16 3.77-2a.92.92 0 01.5-.04z"
            />
          </g>
          <g v-if="name === 'star-filled'">
            <path
              d="M17.56,21a1,1,0,0,1-.46-.11L12,18.22,6.9,20.89a1,1,0,0,1-1.45-1.06l1-5.63-4.12-4a1,1,0,0,1-.25-1,1,1,0,0,1,.81-.68l5.7-.83L11.1,2.56a1,1,0,0,1,1.8,0l2.54,5.12,5.7.83a1,1,0,0,1,.81.68,1,1,0,0,1-.25,1l-4.12,4,1,5.63a1,1,0,0,1-.4,1A1,1,0,0,1,17.56,21Z"
            />
          </g>
          <g v-if="name === 'arrow-right'">
            <path
              d="M10 19a1 1 0 01-.64-.23 1 1 0 01-.13-1.41L13.71 12 9.39 6.63a1 1 0 01.15-1.41 1 1 0 011.46.15l4.83 6a1 1 0 010 1.27l-5 6A1 1 0 0110 19z"
            />
          </g>
          <g v-if="name === 'arrow-left'">
            <path
              d="M13.83 19a1 1 0 01-.78-.37l-4.83-6a1 1 0 010-1.27l5-6a1 1 0 011.54 1.28L10.29 12l4.32 5.36a1 1 0 01-.78 1.64z"
            />
          </g>
          <g v-if="name === 'arrow-down'">
            <path
              d="M12 15.5a1 1 0 01-.71-.29l-4-4a1 1 0 111.42-1.42L12 13.1l3.3-3.18a1 1 0 111.38 1.44l-4 3.86a1 1 0 01-.68.28z"
            />
          </g>
          <g v-if="name === 'arrow-up'">
            <path
              d="M16 14.5a1 1 0 01-.71-.29L12 10.9l-3.3 3.18a1 1 0 01-1.41 0 1 1 0 010-1.42l4-3.86a1 1 0 011.4 0l4 4a1 1 0 010 1.42 1 1 0 01-.69.28z"
            />
          </g>
          <g v-if="name === 'search'">
            <path
              d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0019 11a8 8 0 10-8 8 7.92 7.92 0 004.9-1.69l3.39 3.4a1 1 0 001.42 0 1 1 0 000-1.42zM5 11a6 6 0 116 6 6 6 0 01-6-6z"
            />
          </g>
          <g v-if="name === 'email'">
            <path
              d="M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-.67 2L12 10.75 5.67 6zM19 18H5a1 1 0 01-1-1V7.25l7.4 5.55a1 1 0 00.6.2 1 1 0 00.6-.2L20 7.25V17a1 1 0 01-1 1z"
            />
          </g>
          <g v-if="name === 'emails'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3 2.66667C3 1.22845 4.19907 0 5.75 0H15.25C16.8009 0 18 1.22845 18 2.66667V9.33333C18 10.7716 16.8009 12 15.25 12V10.6667C15.9438 10.6667 16.5714 10.1004 16.5714 9.33333V2.66667C16.5714 1.89955 15.9438 1.33333 15.25 1.33333H5.75C5.05621 1.33333 4.42857 1.89955 4.42857 2.66667H3Z"
              fill="#808080"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 4.66667C1 3.22845 2.19907 2 3.75 2H13.25C14.8009 2 16 3.22845 16 4.66667V11.3333C16 12.7716 14.8009 14 13.25 14V12.6667C13.9438 12.6667 14.5714 12.1004 14.5714 11.3333V4.66667C14.5714 3.89955 13.9438 3.33333 13.25 3.33333H3.75C3.05621 3.33333 2.42857 3.89955 2.42857 4.66667H1Z"
              fill="#808080"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5909 13.6364H2.04545C1.66977 13.6364 1.36364 13.3309 1.36364 12.9545V6.30682L6.40909 10.0909C6.53045 10.1823 6.67432 10.2273 6.81818 10.2273C6.96205 10.2273 7.10591 10.1823 7.22727 10.0909L12.2727 6.30682V12.9545C12.2727 13.3309 11.9666 13.6364 11.5909 13.6364ZM11.1361 5.45455L6.81818 8.69318L2.50022 5.45455H11.1361ZM11.5909 4.09094H2.04545C0.917727 4.09094 0 5.00867 0 6.1364V12.9546C0 14.0823 0.917727 15 2.04545 15H11.5909C12.7186 15 13.6364 14.0823 13.6364 12.9546V6.1364C13.6364 5.00867 12.7186 4.09094 11.5909 4.09094Z"
              fill="#808080"
            />
          </g>
          <g v-if="name === 'email-open'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20 6c-1-.5-7.5-5-8-5S5 5.5 4 6 2 7.346 2 9v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V9c0-1.654-1-2.5-2-3Z"
              fill="#231F20"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m19 8-7 4-7-4 7-5 7 5Z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19 20H5c-.551 0-1-.448-1-1V9.25l7.4 4.55a.995.995 0 0 0 1.2 0L20 9.25V19c0 .552-.449 1-1 1Z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 12c1.26-.42 2.201-1 4.445-1 1.409 0 1.055-1 1.555-1V4.5C18 3.122 16.854 2 15.445 2H8.556C7.147 2 6 3.122 6 4.5v4.222L12 12Z"
              fill="#231F20"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.556 4h6.889c.306 0 .555.224.555.5v5.146L12 12 8 9.708V4.5c0-.276.25-.5.556-.5Z"
              fill="#fff"
            />
          </g>
          <g v-if="name === 'phone'">
            <path
              d="M17.4 22A15.42 15.42 0 012 6.6 4.6 4.6 0 016.6 2a3.94 3.94 0 01.77.07 3.79 3.79 0 01.72.18 1 1 0 01.65.75l1.37 6a1 1 0 01-.26.92c-.13.14-.14.15-1.37.79a9.91 9.91 0 004.87 4.89c.65-1.24.66-1.25.8-1.38a1 1 0 01.92-.26l6 1.37a1 1 0 01.72.65 4.34 4.34 0 01.19.73 4.77 4.77 0 01.06.76A4.6 4.6 0 0117.4 22zM6.6 4A2.61 2.61 0 004 6.6 13.41 13.41 0 0017.4 20a2.61 2.61 0 002.6-2.6v-.33L15.36 16l-.29.55c-.45.87-.78 1.5-1.62 1.16a11.85 11.85 0 01-7.18-7.21c-.36-.78.32-1.14 1.18-1.59L8 8.64 6.93 4z"
            />
          </g>
          <g v-if="name === 'person'">
            <path
              d="M12 11a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM12 13a7 7 0 00-7 7 1 1 0 002 0 5 5 0 0110 0 1 1 0 002 0 7 7 0 00-7-7z"
            />
          </g>
          <g v-if="name === 'shopping-cart'">
            <path
              d="M21.08 7a2 2 0 00-1.7-1H6.58L6 3.74A1 1 0 005 3H3a1 1 0 000 2h1.24L7 15.26A1 1 0 008 16h9a1 1 0 00.89-.55l3.28-6.56A2 2 0 0021.08 7zm-4.7 7H8.76L7.13 8h12.25z"
            />
            <circle cx="7.5" cy="19.5" r="1.5" />
            <circle cx="17.5" cy="19.5" r="1.5" />
          </g>
          <g v-if="name === 'message'">
            <circle cx="12" cy="11" r="1" />
            <circle cx="16" cy="11" r="1" />
            <circle cx="8" cy="11" r="1" />
            <path
              d="M19 3H5a3 3 0 00-3 3v15a1 1 0 00.51.87A1 1 0 003 22a1 1 0 00.51-.14L8 19.14a1 1 0 01.55-.14H19a3 3 0 003-3V6a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H8.55a3 3 0 00-1.55.43l-3 1.8V6a1 1 0 011-1h14a1 1 0 011 1z"
            />
          </g>
          <g v-if="name === 'message-circle'">
            <circle cx="12" cy="12" r="1" />
            <circle cx="16" cy="12" r="1" />
            <circle cx="8" cy="12" r="1" />
            <path
              d="M19.07 4.93a10 10 0 00-16.28 11 1.06 1.06 0 01.09.64L2 20.8a1 1 0 00.27.91A1 1 0 003 22h.2l4.28-.86a1.26 1.26 0 01.64.09 10 10 0 0011-16.28zm.83 8.36a8 8 0 01-11 6.08 3.26 3.26 0 00-1.25-.26 3.43 3.43 0 00-.56.05l-2.82.57.57-2.82a3.09 3.09 0 00-.21-1.81 8 8 0 016.08-11 8 8 0 019.19 9.19z"
            />
          </g>
          <g v-if="name === 'globe'">
            <path
              d="M22 12A10 10 0 0012 2a10 10 0 000 20 10 10 0 0010-10zm-2.07-1H17a12.91 12.91 0 00-2.33-6.54A8 8 0 0119.93 11zM9.08 13H15a11.44 11.44 0 01-3 6.61A11 11 0 019.08 13zm0-2A11.4 11.4 0 0112 4.4a11.19 11.19 0 013 6.6zm.36-6.57A13.18 13.18 0 007.07 11h-3a8 8 0 015.37-6.57zM4.07 13h3a12.86 12.86 0 002.35 6.56A8 8 0 014.07 13zm10.55 6.55A13.14 13.14 0 0017 13h2.95a8 8 0 01-5.33 6.55z"
            />
          </g>
          <g v-if="name === 'close'">
            <path
              d="M13.41 12l4.3-4.29a1 1 0 10-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 00-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 000 1.42 1 1 0 001.42 0l4.29-4.3 4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42z"
            />
          </g>
          <g v-if="name === 'close-square'">
            <path
              d="M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1z"
            />
            <path
              d="M14.71 9.29a1 1 0 00-1.42 0L12 10.59l-1.29-1.3a1 1 0 00-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 000 1.42 1 1 0 001.42 0l1.29-1.3 1.29 1.3a1 1 0 001.42 0 1 1 0 000-1.42L13.41 12l1.3-1.29a1 1 0 000-1.42z"
            />
          </g>
          <g v-if="name === 'invisible'">
            <path
              d="M4.71 3.29a1 1 0 00-1.42 1.42l5.63 5.63a3.5 3.5 0 004.74 4.74l5.63 5.63a1 1 0 001.42 0 1 1 0 000-1.42zM12 13.5a1.5 1.5 0 01-1.5-1.5v-.07l1.56 1.56z"
            />
            <path
              class="cls-2"
              d="M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 012.24-2.72L5 7.87a15.89 15.89 0 00-2.87 3.63 1 1 0 000 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 003.23-.67l-1.58-1.58a7.74 7.74 0 01-1.7.25zM21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 00-3.23.67l1.58 1.58a7.74 7.74 0 011.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 01-2.29 2.72L19 16.13a15.89 15.89 0 002.91-3.63 1 1 0 00-.04-1z"
            />
          </g>
          <g v-if="name === 'people'">
            <path
              d="M9 11a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM17 13a3 3 0 10-3-3 3 3 0 003 3zm0-4a1 1 0 11-1 1 1 1 0 011-1zM17 14a5 5 0 00-3.06 1.05A7 7 0 002 20a1 1 0 002 0 5 5 0 0110 0 1 1 0 002 0 6.9 6.9 0 00-.86-3.35A3 3 0 0120 19a1 1 0 002 0 5 5 0 00-5-5z"
            />
          </g>
          <g v-if="name === 'gender'">
            <path
              d="M16 2v2h3.586l-3.972 3.972A8.96 8.96 0 0010 6a9 9 0 109 9 8.96 8.96 0 00-1.972-5.614L21 5.414V9h2V2h-7zm-6 20c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
            />
          </g>
          <g v-if="name === 'undo'">
            <path
              d="M20.22 21a1 1 0 01-1-.76 8.91 8.91 0 00-7.8-6.69v1.12a1.78 1.78 0 01-1.09 1.64A2 2 0 018.18 16l-5.06-4.41a1.76 1.76 0 010-2.68l5.06-4.42a2 2 0 012.18-.3 1.78 1.78 0 011.09 1.64V7A10.89 10.89 0 0121.5 17.75a10.29 10.29 0 01-.31 2.49 1 1 0 01-1 .76zm-9.77-9.5a11.07 11.07 0 018.81 4.26A9 9 0 0010.45 9a1 1 0 01-1-1V6.08l-4.82 4.17 4.82 4.21v-2a1 1 0 011-.96z"
            />
          </g>
          <g v-if="name === 'arrow-double-right'">
            <path
              d="M18.78 11.37l-4.78-6a1 1 0 00-1.41-.15 1 1 0 00-.15 1.41L16.71 12l-4.48 5.37a1 1 0 00.13 1.41A1 1 0 0013 19a1 1 0 00.77-.36l5-6a1 1 0 00.01-1.27z"
            />
            <path
              d="M7 5.37a1 1 0 00-1.61 1.26L9.71 12l-4.48 5.36a1 1 0 00.13 1.41A1 1 0 006 19a1 1 0 00.77-.36l5-6a1 1 0 000-1.27z"
            />
          </g>
          <g v-if="name === 'scissors'">
            <path
              d="M20.21 5.71a1 1 0 10-1.42-1.42l-6.28 6.31-3.3-3.31A3 3 0 009.5 6a3 3 0 10-3 3 3 3 0 001.29-.3L11.1 12l-3.29 3.3A3 3 0 006.5 15a3 3 0 103 3 3 3 0 00-.29-1.26zM6.5 7a1 1 0 111-1 1 1 0 01-1 1zm0 12a1 1 0 111-1 1 1 0 01-1 1z"
            />
            <path
              d="M15.21 13.29a1 1 0 00-1.42 1.42l5 5a1 1 0 001.42 0 1 1 0 000-1.42z"
            />
          </g>
          <g v-if="name === 'home'">
            <path
              d="M20.42 10.18L12.71 2.3a1 1 0 00-1.42 0l-7.71 7.89A2 2 0 003 11.62V20a2 2 0 001.89 2h14.22A2 2 0 0021 20v-8.38a2.07 2.07 0 00-.58-1.44zM10 20v-6h4v6zm9 0h-3v-7a1 1 0 00-1-1H9a1 1 0 00-1 1v7H5v-8.42l7-7.15 7 7.19z"
            />
          </g>
          <g v-if="name === 'room'">
            <path
              fill="#000000"
              d="M440 424V88h-88V13.005L88 58.522V424H16v32h86.9L352 490.358V120h56v336h88v-32zm-120 29.642l-200-27.586V85.478L320 51z"
            />
            <path fill="#000000" d="M256 232h32v64h-32z" />
          </g>
          <g v-if="name === 'repeat'">
            <path
              d="M17.91 5h-12l1.3-1.29a1 1 0 00-1.42-1.42l-3 3a1 1 0 000 1.42l3 3a1 1 0 001.42 0 1 1 0 000-1.42L5.91 7h12a1.56 1.56 0 011.59 1.53V11a1 1 0 002 0V8.53A3.56 3.56 0 0017.91 5zM18.21 14.29a1 1 0 00-1.42 1.42l1.3 1.29h-12a1.56 1.56 0 01-1.59-1.53V13a1 1 0 00-2 0v2.47A3.56 3.56 0 006.09 19h12l-1.3 1.29a1 1 0 000 1.42 1 1 0 001.42 0l3-3a1 1 0 000-1.42z"
            />
          </g>
          <g v-if="name === 'flip'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.293 7.207a.999.999 0 0 1 0-1.414l3-3a.999.999 0 0 1 1.414 0l3 3a.997.997 0 0 1 0 1.414.999.999 0 0 1-1.414 0L19 5.914V17.91c0 1.98-1.583 3.59-3.529 3.59h-2.47a1 1 0 1 1 0-2h2.47c.843 0 1.53-.713 1.53-1.59V5.914l-1.294 1.293a.999.999 0 0 1-1.414 0ZM5 18.086V6.09C5 4.11 6.583 2.5 8.53 2.5H11a1 1 0 1 1 0 2H8.53C7.686 4.5 7 5.213 7 6.09v11.996l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a.999.999 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L5 18.086Z"
            />
          </g>
          <g v-if="name === 'lock'">
            <path
              d="M17 8h-1V6.11a4 4 0 10-8 0V8H7a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3v-8a3 3 0 00-3-3zm-7-1.89A2.06 2.06 0 0112 4a2.06 2.06 0 012 2.11V8h-4zM18 19a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1z"
            />
            <path
              d="M12 12a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1z"
            />
          </g>
          <g v-if="name === 'unlock'">
            <path
              d="M11 15a1 1 0 102 0 1 1 0 00-2 0zm-2 0c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm8 5a1 1 0 001-1v-8a1 1 0 00-1-1H7a1 1 0 00-1 1v8a1 1 0 001 1h10zM10 8h7c1.654 0 3 1.346 3 3v8c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3v-8c0-1.654 1.346-3 3-3h1V6a4.001 4.001 0 017.229-2.359l.008.028c.213.421-.031.936-.495 1.133l-.238.1c-.402.17-.866.057-1.194-.23-.366-.321-.867-.672-1.31-.672h-.056A2.002 2.002 0 0010 6v2z"
            />
          </g>
          <g v-if="name === 'google'">
            <path
              d="M12 22h-.43A10.16 10.16 0 012 12.29a10 10 0 0114.12-9.41 1.48 1.48 0 01.77.86 1.47 1.47 0 01-.1 1.16L15.5 7.28a1.44 1.44 0 01-1.83.64A4.5 4.5 0 008.77 9a4.41 4.41 0 00-1.16 3.34 4.36 4.36 0 001.66 3 4.52 4.52 0 003.45 1 3.89 3.89 0 002.63-1.57h-2.9A1.45 1.45 0 0111 13.33v-2.68a1.45 1.45 0 011.45-1.45h8.1A1.46 1.46 0 0122 10.64v1.88A10 10 0 0112 22zm0-18a8 8 0 00-8 8.24A8.12 8.12 0 0011.65 20 8 8 0 0020 12.42V11.2h-7v1.58h5.31l-.41 1.3a6 6 0 01-4.9 4.25A6.58 6.58 0 018 17a6.33 6.33 0 01-.72-9.3A6.52 6.52 0 0114 5.91l.77-1.43A7.9 7.9 0 0012 4z"
            />
          </g>
          <g v-if="name === 'smiley_happy'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15 12a1 1 0 00-1 1c0 1.103-.897 2-2 2s-2-.897-2-2a1 1 0 10-2 0c0 2.206 1.794 4 4 4s4-1.794 4-4a1 1 0 00-1-1M15 8a1 1 0 100 2 1 1 0 000-2M9 8a1 1 0 100 2 1 1 0 000-2"
            />
          </g>
          <g v-if="name === 'smiley_sad'">
            >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15 17a1 1 0 01-1-1c0-1.103-.897-2-2-2s-2 .897-2 2a1 1 0 11-2 0c0-2.206 1.794-4 4-4s4 1.794 4 4a1 1 0 01-1 1M15 8a1 1 0 100 2 1 1 0 000-2M9 8a1 1 0 100 2 1 1 0 000-2"
            />
          </g>
          <g v-if="name === 'external_link'">
            <path
              d="M20 11a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h6a1 1 0 000-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z"
            />
            <path
              d="M16 5h1.58l-6.29 6.28a1 1 0 000 1.42 1 1 0 001.42 0L19 6.42V8a1 1 0 001 1 1 1 0 001-1V4a1 1 0 00-1-1h-4a1 1 0 000 2z"
            />
          </g>
          <g v-if="name === 'slash'">
            <path
              d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm8 10a7.92 7.92 0 01-1.69 4.9L7.1 5.69A7.92 7.92 0 0112 4a8 8 0 018 8zM4 12a7.92 7.92 0 011.69-4.9L16.9 18.31A7.92 7.92 0 0112 20a8 8 0 01-8-8z"
            />
          </g>
          <g v-if="name === 'check-square'">
            <path
              d="M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1z"
            />
            <path
              d="M14.7 8.39l-3.78 5-1.63-2.11a1 1 0 00-1.58 1.23l2.43 3.11a1 1 0 00.79.38 1 1 0 00.79-.39l4.57-6a1 1 0 10-1.6-1.22z"
            />
          </g>
          <g v-if="name === 'pin'">
            <path
              d="M12 2a8 8 0 00-8 7.92c0 5.48 7.05 11.58 7.35 11.84a1 1 0 001.3 0C13 21.5 20 15.4 20 9.92A8 8 0 0012 2zm0 17.65c-1.67-1.59-6-6-6-9.73a6 6 0 0112 0c0 3.7-4.33 8.14-6 9.73z"
            />
            <path
              d="M12 6a3.5 3.5 0 103.5 3.5A3.5 3.5 0 0012 6zm0 5a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 11z"
            />
          </g>
          <g v-if="name === 'monitor'">
            <path
              d="M19 3H5a3 3 0 00-3 3v8a3 3 0 003 3h6v2H7a1 1 0 000 2h10a1 1 0 000-2h-4v-2h6a3 3 0 003-3V6a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h14a1 1 0 011 1z"
            />
          </g>
          <g v-if="name === 'move'">
            <path
              d="M21.71 11.31l-3-3a1 1 0 00-1.42 1.42L18.58 11H13V5.41l1.29 1.3A1 1 0 0015 7a1 1 0 00.71-.29 1 1 0 000-1.42l-3-3A1 1 0 0012 2a1 1 0 00-.7.29l-3 3a1 1 0 001.41 1.42L11 5.42V11H5.41l1.3-1.29a1 1 0 00-1.42-1.42l-3 3A1 1 0 002 12a1 1 0 00.29.71l3 3A1 1 0 006 16a1 1 0 00.71-.29 1 1 0 000-1.42L5.42 13H11v5.59l-1.29-1.3a1 1 0 00-1.42 1.42l3 3A1 1 0 0012 22a1 1 0 00.7-.29l3-3a1 1 0 00-1.42-1.42L13 18.58V13h5.59l-1.3 1.29a1 1 0 000 1.42A1 1 0 0018 16a1 1 0 00.71-.29l3-3A1 1 0 0022 12a1 1 0 00-.29-.69z"
            />
          </g>
          <g v-if="name === 'plus'">
            <path
              d="M19 11h-6V5a1 1 0 00-2 0v6H5a1 1 0 000 2h6v6a1 1 0 002 0v-6h6a1 1 0 000-2z"
            />
          </g>
          <g v-if="name === 'activity'">
            <path
              d="M14.33 20h-.21a2 2 0 01-1.76-1.58L9.68 6l-2.76 6.4A1 1 0 016 13H3a1 1 0 010-2h2.34l2.51-5.79a2 2 0 013.79.38L14.32 18l2.76-6.38A1 1 0 0118 11h3a1 1 0 010 2h-2.34l-2.51 5.79A2 2 0 0114.33 20z"
            />
          </g>
          <g v-if="name === 'settings'">
            <path
              d="M8.61 22a2.25 2.25 0 01-1.35-.46L5.19 20a2.37 2.37 0 01-.49-3.22 2.06 2.06 0 00.23-1.86l-.06-.16a1.83 1.83 0 00-1.12-1.22h-.16a2.34 2.34 0 01-1.48-2.94L2.93 8a2.18 2.18 0 011.12-1.41 2.14 2.14 0 011.68-.12 1.93 1.93 0 001.78-.29l.13-.1a1.94 1.94 0 00.73-1.51v-.24A2.32 2.32 0 0110.66 2h2.55a2.26 2.26 0 011.6.67 2.37 2.37 0 01.68 1.68v.28a1.76 1.76 0 00.69 1.43l.11.08a1.74 1.74 0 001.59.26l.34-.11A2.26 2.26 0 0121.1 7.8l.79 2.52a2.36 2.36 0 01-1.46 2.93l-.2.07A1.89 1.89 0 0019 14.6a2 2 0 00.25 1.65l.26.38a2.38 2.38 0 01-.5 3.23L17 21.41a2.24 2.24 0 01-3.22-.53l-.12-.17a1.75 1.75 0 00-1.5-.78 1.8 1.8 0 00-1.43.77l-.23.33A2.25 2.25 0 019 22a2 2 0 01-.39 0zM4.4 11.62a3.83 3.83 0 012.38 2.5v.12a4 4 0 01-.46 3.62.38.38 0 000 .51L8.47 20a.25.25 0 00.37-.07l.23-.33a3.77 3.77 0 016.2 0l.12.18a.3.3 0 00.18.12.25.25 0 00.19-.05l2.06-1.56a.36.36 0 00.07-.49l-.26-.38A4 4 0 0117.1 14a3.92 3.92 0 012.49-2.61l.2-.07a.34.34 0 00.19-.44l-.78-2.49a.35.35 0 00-.2-.19.21.21 0 00-.19 0l-.34.11a3.74 3.74 0 01-3.43-.57L15 7.65a3.76 3.76 0 01-1.49-3v-.31a.37.37 0 00-.1-.26.31.31 0 00-.21-.08h-2.54a.31.31 0 00-.29.33v.25a3.9 3.9 0 01-1.52 3.09l-.13.1a3.91 3.91 0 01-3.63.59.22.22 0 00-.14 0 .28.28 0 00-.12.15L4 11.12a.36.36 0 00.22.45z"
              data-name="&lt;Group&gt;"
            />
            <path
              d="M12 15.5a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zm0-5a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5z"
            />
          </g>
          <g v-if="name === 'eye'">
            <path
              d="M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 000 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 000-1zM12.22 17c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5z"
            />
            <path
              d="M12 8.5a3.5 3.5 0 103.5 3.5A3.5 3.5 0 0012 8.5zm0 5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z"
            />
          </g>
          <g v-if="name === 'logout'">
            <path
              d="M7 6a1 1 0 000-2H5a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 000-2H6V6zM20.82 11.42l-2.82-4a1 1 0 00-1.39-.24 1 1 0 00-.24 1.4L18.09 11H10a1 1 0 000 2h8l-1.8 2.4a1 1 0 00.2 1.4 1 1 0 00.6.2 1 1 0 00.8-.4l3-4a1 1 0 00.02-1.18z"
            />
          </g>
          <g v-if="name === 'person-add'">
            <path
              d="M21 6h-1V5a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0V8h1a1 1 0 000-2zM10 11a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM10 13a7 7 0 00-7 7 1 1 0 002 0 5 5 0 0110 0 1 1 0 002 0 7 7 0 00-7-7z"
            />
          </g>
          <g v-if="name === 'info'">
            <path
              d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"
            />
            <circle cx="12" cy="8" r="1" />
            <path d="M12 10a1 1 0 00-1 1v5a1 1 0 002 0v-5a1 1 0 00-1-1z" />
          </g>
          <g v-if="name === 'bulb'">
            <path
              d="M12 7a5 5 0 00-3 9v4a2 2 0 002 2h2a2 2 0 002-2v-4a5 5 0 00-3-9zm1.5 7.59a1 1 0 00-.5.87V20h-2v-4.54a1 1 0 00-.5-.87A3 3 0 019 12a3 3 0 016 0 3 3 0 01-1.5 2.59zM12 6a1 1 0 001-1V3a1 1 0 00-2 0v2a1 1 0 001 1zM21 11h-2a1 1 0 000 2h2a1 1 0 000-2zM5 11H3a1 1 0 000 2h2a1 1 0 000-2zM7.66 6.42L6.22 5a1 1 0 00-1.39 1.47l1.44 1.39a1 1 0 00.73.28 1 1 0 00.72-.31 1 1 0 00-.06-1.41zM19.19 5.05a1 1 0 00-1.41 0l-1.44 1.37a1 1 0 000 1.41 1 1 0 00.72.31 1 1 0 00.69-.28l1.44-1.39a1 1 0 000-1.42z"
            />
          </g>
          <g v-if="name === 'question-mark'">
            <path
              d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"
            />
            <path
              d="M12 6a3.5 3.5 0 00-3.5 3.5 1 1 0 002 0A1.5 1.5 0 1112 11a1 1 0 00-1 1v2a1 1 0 002 0v-1.16A3.49 3.49 0 0012 6z"
            />
            <circle cx="12" cy="17" r="1" />
          </g>
          <g v-if="name === 'paper-plane'">
            <path
              d="M21 4a1.31 1.31 0 00-.06-.27v-.09a1 1 0 00-.2-.3 1 1 0 00-.29-.19h-.09a.86.86 0 00-.31-.15H20a1 1 0 00-.3 0l-18 6a1 1 0 000 1.9l8.53 2.84 2.84 8.53a1 1 0 001.9 0l6-18A1 1 0 0021 4zm-4.7 2.29l-5.57 5.57L5.16 10zM14 18.84l-1.86-5.57 5.57-5.57z"
            />
          </g>
          <g v-if="name === 'book'">
            <path
              d="M19 3H7a3 3 0 00-3 3v12a3 3 0 003 3h12a1 1 0 001-1V4a1 1 0 00-1-1zM7 5h11v10H7a3 3 0 00-1 .18V6a1 1 0 011-1zm0 14a1 1 0 010-2h11v2z"
            />
          </g>
          <g v-if="name === 'eye-off'">
            <path
              d="M4.71 3.29a1 1 0 00-1.42 1.42l5.63 5.63a3.5 3.5 0 004.74 4.74l5.63 5.63a1 1 0 001.42 0 1 1 0 000-1.42zM12 13.5a1.5 1.5 0 01-1.5-1.5v-.07l1.56 1.56z"
            />
            <path
              d="M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 012.24-2.72L5 7.87a15.89 15.89 0 00-2.87 3.63 1 1 0 000 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 003.23-.67l-1.58-1.58a7.74 7.74 0 01-1.7.25zM21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 00-3.23.67l1.58 1.58a7.74 7.74 0 011.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 01-2.29 2.72L19 16.13a15.89 15.89 0 002.91-3.63 1 1 0 00-.04-1z"
            />
          </g>
          <g v-if="name === 'menu'">
            <rect x="3" y="11" width="18" height="2" rx=".95" ry=".95" />
            <rect x="3" y="16" width="18" height="2" rx=".95" ry=".95" />
            <rect x="3" y="6" width="18" height="2" rx=".95" ry=".95" />
          </g>
          <g v-if="name === 'treatwell'">
            <path
              id="svg_6"
              stroke="null"
              fill="#000000"
              d="m5.05703,14.08833c0,1.48235 0.80391,2.3758 2.13043,2.3758c0.42202,0 0.84414,-0.08121 1.30639,-0.2437l0,0.14212c-0.76376,1.19806 -1.84906,1.86814 -3.21574,1.86814c-1.78877,0 -3.09511,-1.13712 -3.09511,-3.28951l0,-5.68549l-1.72845,0l0,-0.22339l4.36127,-4.00017l0.24121,0l0,9.05621z"
            />
            <path
              id="svg_7"
              stroke="null"
              fill="#000000"
              d="m13.02568,18.16977l1.46714,-3.26921l-3.03484,-7.00539l-5.69753,0l0,1.36044l3.14509,0l3.91916,8.91415l0.20098,0z"
            />
            <path
              id="svg_8"
              stroke="null"
              fill="#000000"
              d="m13.95019,7.89518l3.1353,0l3.03485,7.00538l-1.46721,3.26921l-0.20093,0l-4.50202,-10.27459z"
            />
            <path
              id="svg_9"
              stroke="null"
              fill="#000000"
              d="m21.14532,11.81414c0,-0.97465 -0.4421,-2.92397 -0.9446,-3.91895l3.05493,0l-1.96963,3.91895l-0.1407,0z"
            />
          </g>
          <g v-if="name === 'share'">
            <path
              d="M18 15a3 3 0 00-2.1.86L8 12.34V12v-.33l7.9-3.53A3 3 0 1015 6v.34L7.1 9.86a3 3 0 100 4.28l7.9 3.53V18a3 3 0 103-3zm0-10a1 1 0 11-1 1 1 1 0 011-1zM5 13a1 1 0 111-1 1 1 0 01-1 1zm13 6a1 1 0 111-1 1 1 0 01-1 1z"
              fill="#231f20"
              data-name="share"
            />
          </g>
          <g v-if="name === 'trending'">
            <path
              d="M21 7a.78.78 0 000-.21.64.64 0 00-.05-.17 1.1 1.1 0 00-.09-.14.75.75 0 00-.14-.17l-.12-.07a.69.69 0 00-.19-.1h-.2A.7.7 0 0020 6h-5a1 1 0 000 2h2.83l-4 4.71-4.32-2.57a1 1 0 00-1.28.22l-5 6a1 1 0 00.13 1.41A1 1 0 004 18a1 1 0 00.77-.36l4.45-5.34 4.27 2.56a1 1 0 001.27-.21L19 9.7V12a1 1 0 002 0V7z"
              fill="#231f20"
            />
          </g>
          <g v-if="name === 'mobile'">
            <path
              d="M25.302 0H9.698a2.37 2.37 0 00-2.364 2.364v30.271A2.371 2.371 0 009.698 35h15.604a2.37 2.37 0 002.364-2.364V2.364A2.37 2.37 0 0025.302 0zM15.004 1.704h4.992a.286.286 0 010 .573h-4.992a.286.286 0 110-.573zM17.5 33.818a1.182 1.182 0 110-2.364 1.182 1.182 0 010 2.364zm8.521-3.193H8.979V3.749h17.042v26.876z"
            />
          </g>
          <g v-if="name === 'cloud-upload'">
            <path
              class="cls-2"
              d="M12.71 11.29a1 1 0 00-1.4 0l-3 2.9a1 1 0 101.38 1.44L11 14.36V20a1 1 0 002 0v-5.59l1.29 1.3a1 1 0 001.42 0 1 1 0 000-1.42z"
            />
            <path
              class="cls-2"
              d="M17.67 7A6 6 0 006.33 7a5 5 0 00-3.08 8.27A1 1 0 104.75 14 3 3 0 017 9h.1a1 1 0 001-.8 4 4 0 017.84 0 1 1 0 001 .8H17a3 3 0 012.25 5 1 1 0 00.09 1.42 1 1 0 00.66.25 1 1 0 00.75-.34A5 5 0 0017.67 7z"
            />
          </g>
          <g v-if="name === 'flash'">
            <path
              d="M11.11 23a1 1 0 01-.34-.06 1 1 0 01-.65-1.05l.77-7.09H5a1 1 0 01-.83-1.56l7.89-11.8a1 1 0 011.17-.38 1 1 0 01.65 1l-.77 7.14H19a1 1 0 01.83 1.56l-7.89 11.8a1 1 0 01-.83.44zM6.87 12.8H12a1 1 0 01.74.33 1 1 0 01.25.78l-.45 4.15 4.59-6.86H12a1 1 0 01-1-1.11l.45-4.15z"
            />
          </g>
          <g v-if="name === 'swap'">
            <path
              class="cls-2"
              d="M4 9h13l-1.6 1.2a1 1 0 00-.2 1.4 1 1 0 00.8.4 1 1 0 00.6-.2l4-3a1 1 0 000-1.59l-3.86-3a1 1 0 00-1.23 1.58L17.08 7H4a1 1 0 000 2zM20 16H7l1.6-1.2a1 1 0 00-1.2-1.6l-4 3a1 1 0 000 1.59l3.86 3a1 1 0 00.61.21 1 1 0 00.79-.39 1 1 0 00-.17-1.4L6.92 18H20a1 1 0 000-2z"
            />
          </g>
          <g v-if="name === 'swap-vertical'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 17V4a1 1 0 1 1 2 0v13.082l1.21-1.558a1 1 0 0 1 1.58 1.227l-3 3.862a1 1 0 0 1-1.59-.013l-3-4a.998.998 0 0 1 .2-1.4 1 1 0 0 1 1.4.2L16 17ZM9 7v13a1 1 0 1 1-2 0V6.918L5.79 8.476a1 1 0 0 1-1.58-1.227l3-3.862A1 1 0 0 1 8.8 3.4l3 4a1 1 0 1 1-1.6 1.2L9 7Z"
            />
          </g>
          <g v-if="name === 'brush'">
            <path
              d="M20 6.83a2.76 2.76 0 00-.82-2 2.89 2.89 0 00-4 0l-6.6 6.6h-.22a4.42 4.42 0 00-4.3 4.31L4 19a1 1 0 00.29.73A1.05 1.05 0 005 20l3.26-.06a4.42 4.42 0 004.31-4.3v-.23l6.61-6.6A2.74 2.74 0 0020 6.83zM8.25 17.94L6 18v-2.23a2.4 2.4 0 012.4-2.36 2.15 2.15 0 012.15 2.19 2.4 2.4 0 01-2.3 2.34zm9.52-10.55l-5.87 5.87a4.55 4.55 0 00-.52-.64 3.94 3.94 0 00-.64-.52l5.87-5.86a.84.84 0 011.16 0 .81.81 0 01.23.59.79.79 0 01-.23.56z"
            />
          </g>
          <g v-if="name === 'facebook'">
            <path
              d="M13 22H9a1 1 0 0 1-1-1v-6.2H6a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1h2V7.5A5.77 5.77 0 0 1 14 2h3a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1h-3v1.6h3a1 1 0 0 1 .8.39 1 1 0 0 1 .16.88l-1 3.6a1 1 0 0 1-1 .73H14V21a1 1 0 0 1-1 1zm-3-2h2v-6.2a1 1 0 0 1 1-1h2.24l.44-1.6H13a1 1 0 0 1-1-1V7.5a2 2 0 0 1 2-1.9h2V4h-2a3.78 3.78 0 0 0-4 3.5v2.7a1 1 0 0 1-1 1H7v1.6h2a1 1 0 0 1 1 1z"
            />
          </g>
          <g v-if="name === 'whatsapp'">
            <path
              fill-rule="evenodd"
              d="M5.5 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3.899 2.294c-.507 3.254-3.13 5.953-6.38 6.562a8.003 8.003 0 0 1-4.616-.487 3.215 3.215 0 0 0-1.253-.262c-.19 0-.378.018-.563.055l-2.812.562.563-2.817c.118-.585.046-1.21-.207-1.81a8.01 8.01 0 0 1-.487-4.617c.609-3.249 3.307-5.872 6.562-6.379 2.59-.403 5.123.413 6.95 2.241 1.83 1.83 2.647 4.363 2.243 6.952Zm-.827-8.366C15.287.644 12.127-.375 8.898.124 4.82.76 1.44 4.044.678 8.111a10.008 10.008 0 0 0 .61 5.765c.098.231.128.446.09.64L.52 18.802a.997.997 0 0 0 .274.903.996.996 0 0 0 .903.274l4.283-.857a1.15 1.15 0 0 1 .643.088 10.02 10.02 0 0 0 5.765.611c4.068-.763 7.352-4.143 7.988-8.22.502-3.227-.52-6.389-2.804-8.674Z"
              clip-rule="evenodd"
            />
          </g>
          <g v-if="name === 'options'">
            <path
              d="M19 9a3 3 0 00-2.82 2H3a1 1 0 000 2h13.18A3 3 0 1019 9zm0 4a1 1 0 111-1 1 1 0 01-1 1zM3 7h1.18a3 3 0 005.64 0H21a1 1 0 000-2H9.82a3 3 0 00-5.64 0H3a1 1 0 000 2zm4-2a1 1 0 11-1 1 1 1 0 011-1zM21 17h-7.18a3 3 0 00-5.64 0H3a1 1 0 000 2h5.18a3 3 0 005.64 0H21a1 1 0 000-2zm-10 2a1 1 0 111-1 1 1 0 01-1 1z"
            />
          </g>
          <g v-if="name === 'hash'">
            <path
              d="M20 14h-4.3l.73-4H20a1 1 0 000-2h-3.21l.69-3.81A1 1 0 0016.64 3a1 1 0 00-1.22.82L14.67 8h-3.88l.69-3.81A1 1 0 0010.64 3a1 1 0 00-1.22.82L8.67 8H4a1 1 0 000 2h4.3l-.73 4H4a1 1 0 000 2h3.21l-.69 3.81A1 1 0 007.36 21a1 1 0 001.22-.82L9.33 16h3.88l-.69 3.81a1 1 0 00.84 1.19 1 1 0 001.22-.82l.75-4.18H20a1 1 0 000-2zM9.7 14l.73-4h3.87l-.73 4z"
            />
          </g>
          <g v-if="name === 'stock'">
            <path
              class="cls-2"
              d="M21 6a3 3 0 00-3-3H6a3 3 0 00-2 5.22V18a3 3 0 003 3h10a3 3 0 003-3V8.22A3 3 0 0021 6zM6 5h12a1 1 0 010 2H6a1 1 0 010-2zm12 13a1 1 0 01-1 1H7a1 1 0 01-1-1V9h12z"
            />
            <rect
              class="cls-2"
              x="9"
              y="12"
              width="6"
              height="2"
              rx=".87"
              ry=".87"
            />
          </g>
          <g v-if="name === 'calendar-day'">
            <rect x="2" y="2" width="2" height="20" rx="1" fill="#231F20" />
            <rect x="20" y="2" width="2" height="20" rx="1" fill="#231F20" />
            <path
              d="M6 5a3 3 0 013-3h6a3 3 0 013 3v14a3 3 0 01-3 3H9a3 3 0 01-3-3V5z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15 4H9a1 1 0 00-1 1v14a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1zM9 2a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3H9z"
              fill="#231F20"
            />
          </g>
          <g v-if="name === 'calendar-week'">
            <path
              d="M2 5a3 3 0 013-3h5v20H5a3 3 0 01-3-3V5zM22 5a3 3 0 00-3-3h-5v20h5a3 3 0 003-3V5z"
              fill="#fff"
            />
            <path d="M16 2H8v20h8V2z" fill="#fff" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 4H5a1 1 0 00-1 1v14a1 1 0 001 1h3V4zM5 22h14a3 3 0 003-3V5a3 3 0 00-3-3H5a3 3 0 00-3 3v14a3 3 0 003 3zm9-18h-4v16h4V4zm2 0v16h3a1 1 0 001-1V5a1 1 0 00-1-1h-3z"
              fill="#231F20"
            />
          </g>
          <g v-if="name === 'calendar-month'">
            <path
              d="M5 2a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3H5z"
              fill="#fff"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4 5a1 1 0 011-1h3v4H4V5zm4 5H4v4h4v-4zm2 4v-4h4v4h-4zm-2 2H4v3a1 1 0 001 1h3v-4zm2 4v-4h4v4h-4zm-1 2H5a3 3 0 01-3-3V5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H9zm7-2h3a1 1 0 001-1v-3h-4v4zm0-6h4v-4h-4v4zm0-6h4V5a1 1 0 00-1-1h-3v4zm-2-4h-4v4h4V4z"
              fill="#231F20"
            />
          </g>
          <g v-if="name === 'printer'">
            <path
              d="M19.36 7H18V5a1.92 1.92 0 00-1.83-2H7.83A1.92 1.92 0 006 5v2H4.64A2.66 2.66 0 002 9.67v6.66A2.66 2.66 0 004.64 19h.86a2 2 0 002 2h9a2 2 0 002-2h.86A2.66 2.66 0 0022 16.33V9.67A2.66 2.66 0 0019.36 7zM8 5h8v2H8zm-.5 14v-4h9v4zM20 16.33a.66.66 0 01-.64.67h-.86v-2a2 2 0 00-2-2h-9a2 2 0 00-2 2v2h-.86a.66.66 0 01-.64-.67V9.67A.66.66 0 014.64 9h14.72a.66.66 0 01.64.67z"
            />
          </g>
          <g v-if="name === 'clipboard'">
            <path
              d="M18 5V4a2 2 0 00-2-2H8a2 2 0 00-2 2v1a3 3 0 00-3 3v11a3 3 0 003 3h12a3 3 0 003-3V8a3 3 0 00-3-3zM8 4h8v4H8V4zm11 15a1 1 0 01-1 1H6a1 1 0 01-1-1V8a1 1 0 011-1v1a2 2 0 002 2h8a2 2 0 002-2V7a1 1 0 011 1z"
            />
          </g>
          <g v-if="name === 'edit-2'">
            <path
              d="M19 20H5a1 1 0 000 2h14a1 1 0 000-2zM5 18h.09l4.17-.38a2 2 0 001.21-.57l9-9a1.92 1.92 0 00-.07-2.71L16.66 2.6A2 2 0 0014 2.53l-9 9a2 2 0 00-.57 1.21L4 16.91a1 1 0 00.29.8A1 1 0 005 18zM15.27 4L18 6.73l-2 1.95L13.32 6zm-8.9 8.91L12 7.32l2.7 2.7-5.6 5.6-3 .28z"
            />
          </g>
          <g v-if="name === 'checkmark-circle'">
            <path
              d="M9.71 11.29a1 1 0 00-1.42 1.42l3 3A1 1 0 0012 16a1 1 0 00.72-.34l7-8a1 1 0 00-1.5-1.32L12 13.54z"
            />
            <path
              d="M21 11a1 1 0 00-1 1 8 8 0 01-8 8A8 8 0 016.33 6.36 7.93 7.93 0 0112 4a8.79 8.79 0 011.9.22 1 1 0 10.47-1.94A10.54 10.54 0 0012 2a10 10 0 00-7 17.09A9.93 9.93 0 0012 22a10 10 0 0010-10 1 1 0 00-1-1z"
            />
          </g>
          <g v-if="name === 'chevron-up'">
            <path
              d="M16 14.5a1 1 0 01-.71-.29L12 10.9l-3.3 3.18a1 1 0 01-1.41 0 1 1 0 010-1.42l4-3.86a1 1 0 011.4 0l4 4a1 1 0 010 1.42 1 1 0 01-.69.28z"
            />
          </g>
          <g v-if="name === 'chevron-down'">
            <path
              d="M12 15.5a1 1 0 01-.71-.29l-4-4a1 1 0 111.42-1.42L12 13.1l3.3-3.18a1 1 0 111.38 1.44l-4 3.86a1 1 0 01-.68.28z"
            />
          </g>
          <g v-if="name === 'marketing'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.435 20.825a.992.992 0 0 0 1.031.06c.328-.173.534-.514.534-.885V4a.999.999 0 0 0-1.565-.825L9.023 7.572H3a1 1 0 0 0-1 1v6.857a1 1 0 0 0 1 1h6.023l6.412 4.396ZM9.333 14.43H4V9.572h5.333c.202 0 .399-.062.566-.175L15 5.9v12.203l-5.101-3.498a1.011 1.011 0 0 0-.566-.175Z"
              fill="#231F20"
            />
            <path
              d="m5.78 20.56-1.146-4.925h2.5l1.018 4.372a1.217 1.217 0 1 1-2.371.552Z"
              fill="#231F20"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.774 8.372a1.001 1.001 0 0 0-1.56 1.254c1.037 1.286 1.037 3.46 0 4.746a1 1 0 0 0 1.56 1.254c1.636-2.034 1.636-5.22 0-7.254"
            />
          </g>
          <g v-if="name === 'drag'">
            <circle cx="2" cy="11" r="1" fill="#000" />
            <circle cx="2" cy="7" r="1" fill="#000" />
            <circle cx="2" cy="3" r="1" fill="#000" />
            <circle cx="6" cy="11" r="1" fill="#000" />
            <circle cx="6" cy="7" r="1" fill="#000" />
            <circle cx="6" cy="3" r="1" fill="#000" />
          </g>
          <g v-if="name === 'refresh'">
            <path
              d="M20.3 13.43a1 1 0 0 0-1.25.65A7.14 7.14 0 0 1 12.18 19 7.1 7.1 0 0 1 5 12a7.1 7.1 0 0 1 7.18-7 7.26 7.26 0 0 1 4.65 1.67l-2.17-.36a1 1 0 0 0-1.15.83 1 1 0 0 0 .83 1.15l4.24.7h.17a1 1 0 0 0 .34-.06.33.33 0 0 0 .1-.06.78.78 0 0 0 .2-.11l.09-.11c0-.05.09-.09.13-.15s0-.1.05-.14a1.34 1.34 0 0 0 .07-.18l.75-4a1 1 0 0 0-2-.38l-.27 1.45A9.21 9.21 0 0 0 12.18 3 9.1 9.1 0 0 0 3 12a9.1 9.1 0 0 0 9.18 9A9.12 9.12 0 0 0 21 14.68a1 1 0 0 0-.7-1.25z"
            />
          </g>
          <g v-if="name === 'medical'">
            <path
              fill="#000"
              fill-rule="evenodd"
              d="M20 18c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-8c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v8ZM10 5.5c0-.276.225-.5.5-.5h3c.275 0 .5.224.5.5V7h-4V5.5ZM19 7h-3V5.5C16 4.122 14.879 3 13.5 3h-3C9.121 3 8 4.122 8 5.5V7H5c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3Z"
              clip-rule="evenodd"
            />
            <path
              fill="#000"
              fill-rule="evenodd"
              d="M14 13h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1Z"
              clip-rule="evenodd"
            />
          </g>
          <g v-if="name === 'pwa'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 9.167a.835.835 0 0 0-.833.833v5.833c0 .46.374.834.833.834h10c.46 0 .833-.375.833-.834V10A.835.835 0 0 0 15 9.167h-2.5V7.5h-5v1.667H5Zm10 9.166H5a2.503 2.503 0 0 1-2.5-2.5V10c0-1.378 1.122-2.5 2.5-2.5h10c1.378 0 2.5 1.122 2.5 2.5v5.833c0 1.379-1.122 2.5-2.5 2.5ZM6.667 5.833a.832.832 0 0 1-.5-1.5l3.333-2.5a.833.833 0 0 1 .98-.015l3.332 2.345a.833.833 0 1 1-.958 1.364L10.016 3.53l-2.85 2.137a.828.828 0 0 1-.499.166Z"
              fill="#000"
              fill-opacity=".8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 13.333a.833.833 0 0 1-.833-.833V4.167a.833.833 0 1 1 1.666 0V12.5c0 .46-.372.833-.833.833Z"
              fill="#000"
              fill-opacity=".8"
            />
          </g>
          <g v-if="name === 'archive'">
            <path
              d="M21 6a3 3 0 0 0-3-3H6a3 3 0 0 0-2 5.22V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.22A3 3 0 0 0 21 6zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm12 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h12z"
            />
            <rect width="6" height="2" x="9" y="12" rx=".87" ry=".87" />
          </g>
          <g v-if="name === 'no-wifi'">
            <g data-name="wifi-off">
              <circle cx="12" cy="19" r="1" />
              <path
                d="m12.44 11-1.9-1.89-2.46-2.44-1.55-1.55-1.82-1.83a1 1 0 0 0-1.42 1.42l1.38 1.37 1.46 1.46 2.23 2.24 1.55 1.54 2.74 2.74 2.79 2.8 3.85 3.85a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM21.72 7.93A13.93 13.93 0 0 0 12 4a14.1 14.1 0 0 0-4.44.73l1.62 1.62a11.89 11.89 0 0 1 11.16 3 1 1 0 0 0 .69.28 1 1 0 0 0 .72-.31 1 1 0 0 0-.03-1.39zM3.82 6.65a14.32 14.32 0 0 0-1.54 1.28 1 1 0 0 0 1.38 1.44 13.09 13.09 0 0 1 1.6-1.29zM17 13.14a1 1 0 0 0 .71.3 1 1 0 0 0 .72-1.69A9 9 0 0 0 12 9h-.16l2.35 2.35A7 7 0 0 1 17 13.14zM7.43 10.26a8.8 8.8 0 0 0-1.9 1.49A1 1 0 0 0 7 13.14a7.3 7.3 0 0 1 2-1.41zM8.53 15.4a1 1 0 1 0 1.39 1.44 3.06 3.06 0 0 1 3.84-.25l-2.52-2.52a5 5 0 0 0-2.71 1.33z"
              />
            </g>
          </g>
          <g v-if="name === 'button-clicked'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m14.705 8.395-3.784 4.969-1.633-2.087a.999.999 0 1 0-1.575 1.232l2.43 3.107a1 1 0 0 0 .789.383h.007a.994.994 0 0 0 .788-.394l4.569-6a.999.999 0 1 0-1.591-1.21M20 17c0 .552-.449 1-1 1H5c-.551 0-1-.448-1-1V7c0-.552.449-1 1-1h14c.551 0 1 .448 1 1v10ZM19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3Z"
              fill="#231F20"
            />
          </g>
          <g v-if="name === 'percentage'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z"
              fill="#000"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.74 8.261a.887.887 0 0 0-1.257 0l-6.222 6.222a.886.886 0 0 0 0 1.257.889.889 0 0 0 1.257 0l6.222-6.222a.889.889 0 0 0 0-1.257ZM8.661 7.257a1.499 1.499 0 1 0 1.678 2.486 1.5 1.5 0 1 0-1.678-2.486ZM13.661 14.257a1.499 1.499 0 1 0 1.678 2.486 1.5 1.5 0 1 0-1.678-2.486Z"
              fill="#000"
            />
          </g>
          <g v-if="name === 'play-circle'">
            <rect width="24" height="24" opacity="0" />
            <path
              d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
            />
            <path
              d="M12.34 7.45a1.7 1.7 0 0 0-1.85-.3 1.6 1.6 0 0 0-1 1.48v6.74a1.6 1.6 0 0 0 1 1.48 1.68 1.68 0 0 0 .69.15 1.74 1.74 0 0 0 1.16-.45L16 13.18a1.6 1.6 0 0 0 0-2.36zm-.84 7.15V9.4l2.81 2.6z"
            />
          </g>
          <g v-if="name === 'minus'">
            <path d="M19 13H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" />
          </g>
          <g v-if="name === 'download'">
            <path
              d="M11.5028 12.0759C11.501 12.0508 11.5 12.0255 11.5 12V4C11.5 3.448 11.947 3 12.5 3C13.053 3 13.5 3.448 13.5 4V11.9998L15.9 10.2C16.342 9.867 16.969 9.958 17.3 10.4C17.632 10.842 17.542 11.469 17.1 11.8L13.1 14.8C12.923 14.933 12.711 15 12.5 15C12.299 15 12.098 14.939 11.925 14.818L7.925 12.004C7.473 11.686 7.364 11.062 7.682 10.611C8 10.159 8.623 10.05 9.075 10.368L11.5028 12.0759ZM6.5 17V18H18.5V17C18.5 16.45 18.95 16 19.5 16C20.05 16 20.5 16.45 20.5 17V19C20.5 19.55 20.05 20 19.5 20H5.5C4.95 20 4.5 19.55 4.5 19V17C4.5 16.45 4.95 16 5.5 16C6.05 16 6.5 16.45 6.5 17Z"
            />
          </g>
          <g v-if="name === 'upload'">
            <path
              d="M5 4H19C19.55 4 20 4.45 20 5V7C20 7.55 19.55 8 19 8C18.45 8 18 7.55 18 7V6H6V7C6 7.55 5.55 8 5 8C4.45 8 4 7.55 4 7V5C4 4.45 4.45 4 5 4ZM8.001 14C7.696 14 7.397 13.862 7.2 13.6C6.868 13.158 6.958 12.531 7.4 12.2L11.4 9.2C11.746 8.94 12.222 8.933 12.575 9.182L16.575 11.996C17.027 12.314 17.136 12.938 16.818 13.389C16.5 13.84 15.877 13.95 15.425 13.632L12.9972 11.9241C12.999 11.9492 13 11.9745 13 12V20C13 20.552 12.553 21 12 21C11.447 21 11 20.552 11 20V12.0002L8.6 13.8C8.42 13.935 8.21 14 8.001 14Z"
            />
          </g>
          <g v-if="name === 'wifi'">
            <g data-name="wifi">
              <rect width="24" height="24" opacity="0" />
              <circle cx="12" cy="19" r="1" />
              <path
                d="M12 14a5 5 0 0 0-3.47 1.4 1 1 0 1 0 1.39 1.44 3.08 3.08 0 0 1 4.16 0 1 1 0 1 0 1.39-1.44A5 5 0 0 0 12 14z"
              />
              <path
                d="M12 9a9 9 0 0 0-6.47 2.75A1 1 0 0 0 7 13.14a7 7 0 0 1 10.08 0 1 1 0 0 0 .71.3 1 1 0 0 0 .72-1.69A9 9 0 0 0 12 9z"
              />
              <path
                d="M21.72 7.93a14 14 0 0 0-19.44 0 1 1 0 0 0 1.38 1.44 12 12 0 0 1 16.68 0 1 1 0 0 0 .69.28 1 1 0 0 0 .72-.31 1 1 0 0 0-.03-1.41z"
              />
            </g>
          </g>
          <g v-if="name === 'salonized-terminal'">
            <path
              clip-rule="evenodd"
              d="M8.99966 16.5H7.20966C5.10366 16.5 3.20366 14.965 3.01666 12.866C2.80366 10.496 4.67266 8.5 6.99966 8.5H8.99966C9.55166 8.5 9.99966 8.053 9.99966 7.5C9.99966 6.947 9.55166 6.5 8.99966 6.5H7.20866C4.15966 6.5 1.43866 8.687 1.05066 11.711C0.581663 15.369 3.43166 18.5 6.99966 18.5H8.99966C9.55166 18.5 9.99966 18.053 9.99966 17.5C9.99966 16.947 9.55166 16.5 8.99966 16.5ZM7.99966 12.5C7.99966 13.053 8.44766 13.5 8.99966 13.5H14.9997C15.5517 13.5 15.9997 13.053 15.9997 12.5C15.9997 11.947 15.5517 11.5 14.9997 11.5H8.99966C8.44766 11.5 7.99966 11.947 7.99966 12.5ZM16.7588 6.5002C19.8258 6.5002 22.5778 8.6972 22.9528 11.7422C23.4018 15.3882 20.5578 18.5002 16.9998 18.5002H14.9998C14.4478 18.5002 13.9998 18.0532 13.9998 17.5002C13.9998 16.9472 14.4478 16.5002 14.9998 16.5002H16.9998C19.3268 16.5002 21.1958 14.5042 20.9828 12.1342C20.7958 10.0352 18.8958 8.5002 16.7888 8.5002H14.9998C14.4478 8.5002 13.9998 8.0532 13.9998 7.5002C13.9998 6.9472 14.4428 6.5002 15.2488 6.5002H16.7588Z"
              fill="#828282"
            />
          </g>
          <g v-if="name === 'terminal'">
            <path
              clip-rule="evenodd"
              d="M3.5 11.5001C3.5 9.55915 4.438 7.70015 6.144 6.26615C6.566 5.90915 6.621 5.27815 6.266 4.85615C5.909 4.43415 5.279 4.37915 4.856 4.73415C2.692 6.55615 1.5 8.95915 1.5 11.5001C1.5 14.0411 2.692 16.4441 4.856 18.2661C5.044 18.4231 5.272 18.5001 5.499 18.5001C5.784 18.5001 6.067 18.3791 6.266 18.1441C6.621 17.7221 6.566 17.0911 6.144 16.7341C4.438 15.3001 3.5 13.4411 3.5 11.5001ZM12 12.5001C11.448 12.5001 11 12.0521 11 11.5001C11 10.9481 11.448 10.5001 12 10.5001C12.552 10.5001 13 10.9481 13 11.5001C13 12.0521 12.552 12.5001 12 12.5001ZM12 8.50015C10.346 8.50015 9 9.84615 9 11.5001C9 12.8141 9.855 13.9221 11.035 14.3261C11.0311 14.3471 11.0255 14.3674 11.02 14.3875L11.02 14.3875L11.02 14.3876L11.02 14.3876C11.0099 14.4241 11 14.4602 11 14.5001V20.5001C11 21.0531 11.447 21.5001 12 21.5001C12.553 21.5001 13 21.0531 13 20.5001V14.5001C13 14.4602 12.9901 14.4241 12.98 14.3876L12.98 14.3876L12.98 14.3875L12.98 14.3875C12.9745 14.3674 12.9689 14.3471 12.965 14.3261C14.145 13.9221 15 12.8141 15 11.5001C15 9.84615 13.654 8.50015 12 8.50015ZM15.2356 6.85655C15.5896 6.43455 16.2206 6.37855 16.6436 6.73555C18.1636 8.01355 18.9996 9.70655 18.9996 11.5005C18.9996 13.2945 18.1636 14.9865 16.6436 16.2645C16.4566 16.4235 16.2276 16.5005 16.0006 16.5005C15.7156 16.5005 15.4326 16.3795 15.2356 16.1435C14.8786 15.7215 14.9336 15.0905 15.3566 14.7355C16.4156 13.8425 16.9996 12.6935 16.9996 11.5005C16.9996 10.3065 16.4156 9.15755 15.3566 8.26455C14.9336 7.90955 14.8786 7.27855 15.2356 6.85655ZM8.7646 6.85655C8.4106 6.43355 7.7806 6.37755 7.3566 6.73555C5.8366 8.01355 4.9996 9.70655 4.9996 11.5005C4.9996 13.2935 5.8366 14.9865 7.3566 16.2645C7.5436 16.4225 7.7726 16.5005 7.9986 16.5005C8.2846 16.5005 8.5676 16.3785 8.7646 16.1435C9.1206 15.7215 9.0666 15.0905 8.6436 14.7355C7.5836 13.8425 6.9996 12.6935 6.9996 11.5005C6.9996 10.3065 7.5836 9.15755 8.6436 8.26455C9.0666 7.90955 9.1206 7.27855 8.7646 6.85655ZM17.7346 4.85655C18.0906 4.43455 18.7196 4.38055 19.1436 4.73455C21.3076 6.55555 22.4996 8.95955 22.4996 11.5005C22.4996 14.0415 21.3076 16.4445 19.1436 18.2655C18.9566 18.4225 18.7276 18.5005 18.5006 18.5005C18.2156 18.5005 17.9326 18.3795 17.7346 18.1435C17.3786 17.7215 17.4336 17.0905 17.8566 16.7345C19.5616 15.2995 20.4996 13.4415 20.4996 11.5005C20.4996 9.55855 19.5616 7.70055 17.8566 6.26555C17.4336 5.90955 17.3786 5.27855 17.7346 4.85655Z"
              fill="#828282"
            />
          </g>
          <g v-if="name === 'book-open'">
            <path
              d="M20.62 4.22a1 1 0 0 0-.84-.2L12 5.77 4.22 4A1 1 0 0 0 3 5v12.2a1 1 0 0 0 .78 1l8 1.8h.44l8-1.8a1 1 0 0 0 .78-1V5a1 1 0 0 0-.38-.78zM5 6.25l6 1.35v10.15L5 16.4zM19 16.4l-6 1.35V7.6l6-1.35z"
              data-name="book-open"
            />
          </g>
          <g v-if="name === 'new-tab'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19 18.5V12.5C19 11.948 19.447 11.5 20 11.5C20.553 11.5 21 11.948 21 12.5V18.5C21 20.154 19.654 21.5 18 21.5H6C4.346 21.5 3 20.154 3 18.5V6.5C3 4.846 4.346 3.5 6 3.5H12C12.553 3.5 13 3.948 13 4.5C13 5.052 12.553 5.5 12 5.5H6C5.448 5.5 5 5.949 5 6.5V18.5C5 19.051 5.448 19.5 6 19.5H18C18.552 19.5 19 19.051 19 18.5ZM17.5781 5.508L15.9951 5.5C15.4421 5.497 14.9971 5.047 15.0001 4.495C15.0031 3.944 15.4501 3.5 16.0001 3.5H16.0051L20.0021 3.52C20.5521 3.523 20.9971 3.969 20.9971 4.519L21.0001 8.499C21.0001 9.052 20.5531 9.5 20.0011 9.5H20.0001C19.4481 9.5 19.0001 9.053 19.0001 8.501L18.9991 6.915L12.7071 13.207C12.5121 13.402 12.2561 13.5 12.0001 13.5C11.7441 13.5 11.4881 13.402 11.2931 13.207C10.9021 12.816 10.9021 12.184 11.2931 11.793L17.5781 5.508Z"
              fill="#4F4F4F"
            />
          </g>
          <g v-if="name === 'circle-x'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.207 11.3599C13.598 11.7509 13.598 12.3829 13.207 12.7739C13.012 12.9689 12.756 13.0669 12.5 13.0669C12.244 13.0669 11.988 12.9689 11.793 12.7739L10.5 11.4809L9.207 12.7739C9.012 12.9689 8.756 13.0669 8.5 13.0669C8.244 13.0669 7.988 12.9689 7.793 12.7739C7.402 12.3829 7.402 11.7509 7.793 11.3599L9.086 10.0669L7.793 8.77389C7.402 8.38289 7.402 7.75089 7.793 7.35989C8.184 6.96889 8.816 6.96889 9.207 7.35989L10.5 8.65289L11.793 7.35989C12.184 6.96889 12.816 6.96889 13.207 7.35989C13.598 7.75089 13.598 8.38289 13.207 8.77389L11.914 10.0669L13.207 11.3599ZM10.5 0.0668945C4.986 0.0668945 0.5 4.55289 0.5 10.0669C0.5 15.5809 4.986 20.0669 10.5 20.0669C16.014 20.0669 20.5 15.5809 20.5 10.0669C20.5 4.55289 16.014 0.0668945 10.5 0.0668945Z"
            />
          </g>
          <g v-if="name === 'circle-check'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.795 7.67238L10.227 13.6724C10.039 13.9194 9.748 14.0654 9.438 14.0674H9.431C9.124 14.0674 8.834 13.9254 8.644 13.6834L6.212 10.5764C5.872 10.1424 5.948 9.51338 6.383 9.17338C6.817 8.83238 7.447 8.90838 7.787 9.34438L9.42 11.4304L13.204 6.46138C13.538 6.02238 14.165 5.93638 14.606 6.27138C15.045 6.60638 15.13 7.23338 14.795 7.67238ZM10.5 0.0673828C4.977 0.0673828 0.5 4.54438 0.5 10.0674C0.5 15.5894 4.977 20.0674 10.5 20.0674C16.023 20.0674 20.5 15.5894 20.5 10.0674C20.5 4.54438 16.023 0.0673828 10.5 0.0673828Z"
            />
          </g>
          <g v-if="name === 'toggle-left'">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.50002 10.8333C7.04002 10.8333 6.66669 10.46 6.66669 9.99996C6.66669 9.53996 7.04002 9.16663 7.50002 9.16663C7.96002 9.16663 8.33335 9.53996 8.33335 9.99996C8.33335 10.46 7.96002 10.8333 7.50002 10.8333ZM7.50002 7.49996C6.12169 7.49996 5.00002 8.62163 5.00002 9.99996C5.00002 11.3783 6.12169 12.5 7.50002 12.5C8.87835 12.5 10 11.3783 10 9.99996C10 8.62163 8.87835 7.49996 7.50002 7.49996ZM12.5 14.1666H7.50002C5.20252 14.1666 3.33335 12.2975 3.33335 9.99996C3.33335 7.70246 5.20252 5.83329 7.50002 5.83329H12.5C14.7975 5.83329 16.6667 7.70246 16.6667 9.99996C16.6667 12.2975 14.7975 14.1666 12.5 14.1666ZM12.5 4.16663H7.50002C4.28419 4.16663 1.66669 6.78413 1.66669 9.99996C1.66669 13.2158 4.28419 15.8333 7.50002 15.8333H12.5C15.7159 15.8333 18.3334 13.2158 18.3334 9.99996C18.3334 6.78413 15.7159 4.16663 12.5 4.16663Z"
              fill="#9C9AA0"
            />
          </g>
          <g v-if="name === 'file-add'">
            <g data-name="file-add">
              <rect width="24" height="24" opacity="0" />
              <path
                d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM14 5l2.74 3h-2a.79.79 0 0 1-.74-.85zm3.44 15H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H12v3.15A2.79 2.79 0 0 0 14.71 10H18v9.5a.53.53 0 0 1-.56.5z"
              />
              <path
                d="M14 13h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2z"
              />
            </g>
          </g>
          <g v-if="name === 'award'">
            <g data-name="award">
              <rect width="24" height="24" opacity="0" />
              <path
                d="M19 20.75l-2.31-9A5.94 5.94 0 0 0 18 8 6 6 0 0 0 6 8a5.94 5.94 0 0 0 1.34 3.77L5 20.75a1 1 0 0 0 1.48 1.11l5.33-3.13 5.68 3.14A.91.91 0 0 0 18 22a1 1 0 0 0 1-1.25zM12 4a4 4 0 1 1-4 4 4 4 0 0 1 4-4zm.31 12.71a1 1 0 0 0-1 0l-3.75 2.2L9 13.21a5.94 5.94 0 0 0 5.92 0L16.45 19z"
              />
            </g>
          </g>
          <g v-if="name === 'more-horizontal'">
            <g data-name="more-horizotnal">
              <rect width="24" height="24" opacity="0" />
              <circle cx="12" cy="12" r="2" />
              <circle cx="19" cy="12" r="2" />
              <circle cx="5" cy="12" r="2" />
            </g>
          </g>
          <g v-if="name === 'more-vertical'">
            <g data-name="more-vertical">
              <rect
                width="24"
                height="24"
                transform="rotate(-90 12 12)"
                opacity="0"
              />
              <circle cx="12" cy="12" r="2" />
              <circle cx="12" cy="5" r="2" />
              <circle cx="12" cy="19" r="2" />
            </g>
          </g>
          <g v-if="name === 'close-circle'">
            <g data-name="close-circle">
              <rect width="24" height="24" opacity="0" />
              <path
                d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
              />
              <path
                d="M14.71 9.29a1 1 0 0 0-1.42 0L12 10.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l1.3-1.29a1 1 0 0 0 0-1.42z"
              />
            </g>
          </g>
          <g v-if="name === 'expand'">
            <g data-name="expand">
              <rect
                width="24"
                height="24"
                transform="rotate(180 12 12)"
                opacity="0"
              />
              <path
                d="M20 5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L18 7.42V10a1 1 0 0 0 1 1 1 1 0 0 0 1-1z"
              />
              <path
                d="M10.71 13.29a1 1 0 0 0-1.42 0L6 16.57V14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.42l3.29-3.29a1 1 0 0 0 0-1.42z"
              />
            </g>
          </g>
          <g v-if="name === 'collapse'">
            <g data-name="collapse">
              <rect
                width="24"
                height="24"
                transform="rotate(180 12 12)"
                opacity="0"
              />
              <path
                d="M19 9h-2.58l3.29-3.29a1 1 0 1 0-1.42-1.42L15 7.57V5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2z"
              />
              <path
                d="M10 13H5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.42V19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
              />
            </g>
          </g>
          <g v-if="name === 'shopping-bag'">
            <rect
              width="24"
              height="24"
              transform="rotate(180 12 12)"
              opacity="0"
            />
            <path
              d="M15 11C14.447 11 14 11.448 14 12C14 13.103 13.103 14 12 14C10.897 14 10 13.103 10 12C10 11.448 9.553 11 9 11C8.447 11 8 11.448 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 11.448 15.553 11 15 11ZM18 19H6C5.448 19 5 18.551 5 18V9H19V18C19 18.551 18.552 19 18 19ZM8.121 5.293C8.308 5.107 8.565 5 8.828 5H15.172C15.435 5 15.692 5.107 15.879 5.293L17.586 7H6.414L8.121 5.293ZM20.121 6.707L17.293 3.879C16.727 3.312 15.973 3 15.172 3H8.828C8.027 3 7.273 3.312 6.707 3.879L3.879 6.707C3.312 7.273 3 8.027 3 8.829V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V8.829C21 8.027 20.688 7.273 20.121 6.707Z"
              fill="white"
            />
          </g>
        </svg>
      </div>
    </div>
  </component>
</template>

<script lang="ts">
import Link from '@/components/_shared/Link.vue';

export default {
  components: {
    Link,
  },
  inheritAttrs: false,
  computed: {
    viewBox() {
      if (this.name === 'room') {
        return '0 0 512 512';
      } else if (this.name === 'mobile') {
        return '0 0 35 35';
      } else if (this.name === 'drag') {
        return '0 0 9 15';
      } else if (this.name === 'emails') {
        return '0 0 18 18';
      } else {
        return '0 0 24 24';
      }
    },
  },
};
</script>

<script setup lang="ts">
import type { IconName } from './types';

withDefaults(
  defineProps<{
    clickable?: boolean;
    color?:
      | 'default'
      | 'inverted'
      | 'primary'
      | 'success'
      | 'warning'
      | 'error'
      | 'secondary';
    disabled?: boolean;
    name: IconName;
    routerLink?: {} | string;
    size?: 'xs' | 's' | 'm' | 'l';
  }>(),
  {
    color: 'default',
    size: 'm'
  }
);

defineEmits(['click']);
</script>

<style lang="scss" module>
.base {
  display: inline-block;
  flex-shrink: 0;

  &.xs {
    width: 14px;
    height: 14px;
    padding: 1px;
  }

  &.s {
    width: 16px;
    height: 16px;
  }

  &.m {
    width: 20px;
    height: 20px;
  }

  &.l {
    height: 25px;
    width: 25px;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.2;
  }

  &.clickable {
    @include hover {
      cursor: pointer;
    }
  }
}

.wrap {
  .base.clickable & {
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    margin: -4px;
    padding: 4px;
    @include background-hover;
  }
}

.inner {
  position: relative;
  padding-bottom: 100%;
}

.svg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  &:not(.customIcon) {
    path,
    circle {
      .base.error & {
        fill: $color-error;
      }
      .base.secondary & {
        fill: $color-text-secondary;
      }
      .base.default & {
        fill: #000;
        opacity: 0.5;
      }

      .base.inverted & {
        fill: #fff;
      }

      .base.primary & {
        fill: $color-primary;
      }

      .base.success & {
        fill: $color-success;
      }

      .base.warning & {
        fill: $color-warning;
      }
    }
  }

  &.customIcon {
    opacity: 0.5;
  }
}
</style>
